import { useEffect, useState } from "react";
import apiClient from "../utils/apiClient";

// App config state for AuthProvider: defaults, then fetched from /api/config on mount.
export function useAppConfig() {
  const [appConfig, setAppConfig] = useState({
    mode: "production",
    requiresAuth: true,
    isStableMode: false,
    cookieConsent: {
      consentVersion: "1.0.0",
      infoUrl: "/legal-notice",
      categories: ["first_party", "third_party"],
    },
  });

  // Fetch app config on mount
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const { data } = await apiClient.get("/api/config");

        if (data.ok) {
          setAppConfig({
            mode: data.mode,
            requiresAuth: data.requiresAuth,
            isStableMode: data.isStableMode,
            cookieConsent: data.cookieConsent || {
              consentVersion: "1.0.0",
              infoUrl: "/legal-notice",
              categories: ["first_party", "third_party"],
            },
          });
        }
      } catch (err) {
        console.error("Failed to fetch config:", err);
      }
    };
    fetchConfig();
  }, []);

  return appConfig;
}
